module.exports = __webpack_public_path__ + "static/media/c.a14c2161.jpg";